import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-background-50 px-6 text-center">
      <span className="w-16 h-16 rounded-full bg-accent-50 text-accent-600 flex items-center justify-center">
        <i className="ri-compass-3-line text-3xl"></i>
      </span>
      <div>
        <p className="text-5xl font-semibold font-heading text-foreground-950">404</p>
        <h1 className="mt-2 text-lg font-semibold font-heading text-foreground-900">
          Page introuvable
        </h1>
        <p className="mt-1 text-sm text-foreground-500">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 cursor-pointer"
        >
          <i className="ri-dashboard-3-line"></i>
          Tableau de bord
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          Accueil
        </Link>
      </div>
    </div>
  );
}